<template>

    <main style="margin-top: 25px;">
        <notifications />
        <section>

            <div class="content-960 " style="max-width:400px">
                <div class="wrapper-960 clearfix">
                    <div class="titles">
                        <h2 class="uppercase"><b><i class="fa fa-key"></i> Configurar Acesso</b></h2>
                    </div>
                    <p>
                        Parabéns pela contratação!<br />
                        Neste passo crie e confirme sua senha de acesso, e após isto seu usuário estará liberado para acessar o Portal Corporativo e demais sistemas.
                    </p>
                    <div v-if="mostrarLink">
                        <p>
                            <h6>
                                *Entre no novo
                                <a class="text-primary" @click="abrirPortal()">
                                    <i class="fa fa-external-link"></i> Portal Corporativo
                                </a>
                            </h6>
                        </p>
                    </div>

                    <div class="mold-txt-center" v-if="show_form">
                        <form>
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for="senha">Senha</label>
                                    <input type="password" class="form-control" v-on:keyup="verificaSenha()" name="senha" autocomplete="off" v-model="senha" maxlength="32" required />
                                    <div v-if="senha">
                                        <label>Nível da senha:&nbsp;</label>
                                        <label v-if="nivelSenha == 1" style=" color: red !important;">Fraca</label>
                                        <label v-if="nivelSenha == 2" style=" color: #FFA500 !important;">Mediana</label>
                                        <label v-if="nivelSenha == 3" style=" color: green !important;">Forte</label>
                                    </div>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="senhaConfirmacao">Confirmar Senha</label>
                                    <input type="password" class="form-control" name="senhaConfirmacao" autocomplete="off" v-model="senhaConfirmacao" maxlength="32" required />
                                    <label v-if="senha != senhaConfirmacao && senhaConfirmacao && senha">As senhas diferem</label>
                                </div>
                            </div>

                            <button type="button"
                                    class="btn-large-40 btn-red uppercase"
                                    @click="salvarSenha()">
                                Confirmar
                            </button>

                        </form>
                    </div>
                </div>
            </div>
        </section>
    </main>

</template>
<script>

    import base from '@/common/base.js'
    import Cache from '@/common/cache'
    import Global from '@/common/global'
    import { Api } from '@/common/api'
    import Auth from '@/common/auth'

    export default {
        name: 'contratarConfirmacao',
        mixins: [base],
        components: {},
        data() {
            return {
                senha: "",
                senhaConfirmacao: "",
                chaveAcesso: "",
                viacnajobs: false,
                nivelSenha: 0,
                show_form: true,
                mostrarLink: false,
            }
        },
        methods: {
            verificaSenha: function () {
                this.nivelSenha = 0;

                var temLetra = /([a-z])/.test(this.senha);
                var temEspecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(this.senha);
                var temNumero = /\d/.test(this.senha);

                if (this.senha.length < 6) {
                    this.nivelSenha++;
                    return
                }

                if (temLetra) this.nivelSenha++;
                if (temEspecial) this.nivelSenha++;
                if (temNumero) this.nivelSenha++;
            },
            abrirPortal: function () {
                Auth.logout()
                sessionStorage.clear();
                window.location = Global.URL_PORTAL_CORPORATIVO + "login";
            },
            salvarSenha: function () {
                new Api("candidato/confirmarsenhacandidato").put({
                    chaveAcesso: this.chaveAcesso,
                    attributeBehavior: "ConfirmarSenhaCandidato",
                    colaborador: {
                        senhaMD5: this.senha,
                        senhaMD5Confirm: this.senhaConfirmacao
                    }
                }).then(data => {
                    this.show_form = false;
                    this.defaultSuccessResult("Senha configurada com sucesso, você será redirecionado para o Portal Corporativo.");
                    this.mostrarLink = true;
                    //setTimeout(() => {
                    //    if (this.viacnajobs)
                    //        window.location = "https://www.cna.com.br/";
                    //    else
                    //        window.location = Global.URL_PORTAL_CORPORATIVO;
                    //}, 2000)
                }, err => {
                    this.defaultErrorResult(err);
                });
            }
        },
        mounted() {
            this.configNotification();
            this.chaveAcesso = this.$route.params.chaveAcesso;
            this.viacnajobs = this.$route.query.viacnajobs;
        },
        beforeDestroy() {
            this.$eventHub.$off('show-notification');
        },
    };
</script>